import { render, staticRenderFns } from "./IncMenu.vue?vue&type=template&id=27c706a4&scoped=true"
import script from "./IncMenu.vue?vue&type=script&lang=js"
export * from "./IncMenu.vue?vue&type=script&lang=js"
import style0 from "./IncMenu.vue?vue&type=style&index=0&id=27c706a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c706a4",
  null
  
)

export default component.exports